import "../css/theme.scss";
// import "flowbite";
import "./menu";
import "./animations";
import "./lazyload";

window.addEventListener("load", () => {
  const footerImage = document.querySelector("footer img");
  const headerMenuImages = document.querySelectorAll(
    "#menu-main-menu .mega-menu-wrapper img"
  );

  const buildSrcset = (imageArray) => {
    if (!imageArray || !imageArray.sizes) return "";
    const sizes = imageArray.sizes;
    const srcsetParts = [];

    // Add different sizes to the srcset if they exist
    if (sizes.medium) {
      srcsetParts.push(`${sizes.medium} 500w`);
    }
    if (sizes.large) {
      srcsetParts.push(`${sizes.large} 1024w`);
    }
    if (imageArray.url) {
      srcsetParts.push(`${imageArray.url} 2048w`);
    }

    return srcsetParts.join(", ");
  };

  const buildSizesAttribute = () => {
    // Use a default responsive sizes attribute
    return "(max-width: 600px) 540px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 100vw";
  };

  const loadImageAsync = (imgElement, imageUrl, imageSrcset, imageSizes) => {
    return new Promise((resolve, reject) => {
      const tempImage = new Image();
      tempImage.src = imageUrl;

      // Set srcset and sizes to the temporary image to preload them as well
      if (imageSrcset) {
        tempImage.srcset = imageSrcset;
      }
      if (imageSizes) {
        tempImage.sizes = imageSizes;
      }

      tempImage.onload = () => {
        imgElement.src = imageUrl;
        imgElement.srcset = imageSrcset;
        imgElement.sizes = imageSizes;
        resolve(`Image loaded: ${imageUrl}`);
      };

      tempImage.onerror = (error) => {
        console.error(`Failed to load image: ${imageUrl}`);
        reject(`Error loading image: ${imageUrl}`);
      };
    });
  };

  const lazyLoadShellImages = async () => {
    try {
      const promises = [];

      if (footerImage && WordPress.themeImages.footer_bg) {
        const footerImageUrl = WordPress.themeImages.footer_bg.url;
        const footerImageSrcset = buildSrcset(WordPress.themeImages.footer_bg);
        const footerImageSizes = buildSizesAttribute();

        promises.push(
          loadImageAsync(
            footerImage,
            footerImageUrl,
            footerImageSrcset,
            footerImageSizes
          )
        );
      } else {
        console.warn("Footer image element or data not found.");
      }

      if (headerMenuImages.length > 0 && WordPress.themeImages.menu_bg) {
        const headerImageUrl = WordPress.themeImages.menu_bg.url;
        const headerImageSrcset = buildSrcset(WordPress.themeImages.menu_bg);
        const headerImageSizes = buildSizesAttribute();

        headerMenuImages.forEach((img) => {
          promises.push(
            loadImageAsync(
              img,
              headerImageUrl,
              headerImageSrcset,
              headerImageSizes
            )
          );
        });
      } else {
        console.warn("No header menu images found or data not found.");
      }

      const responses = await Promise.all(promises);
    } catch (error) {
      console.error(`Could not load all images - ${error}`);
    }
  };

  lazyLoadShellImages();

  // Handle form field styling and dynamic email logic
  const inputs = document.querySelectorAll(
    ".contact-form .group input, .contact-form .group textarea, .contact-form .group select"
  );

  const forms = document.querySelectorAll(".wpcf7-form");

  forms.forEach((form) => {
    // Dynamic email logic for select type

    // Reset form logic on submit
    form.addEventListener("submit", () => {
      const valueFields = form.querySelectorAll(".has-content");
      valueFields.forEach((field) => {
        field.classList.remove("has-content");
        const paragraph = field.querySelector("p");
        if (paragraph) {
          paragraph.innerText = "";
        }
      });
    });
  });

  inputs.forEach((input) => {
    if (input) {
      if (input.type == "file") {
        const fileContainer = input.closest(".group");
        const fileNameDisplay = fileContainer.querySelector("p");

        input.addEventListener("change", function () {
          const fileName = this.files.length > 0 ? this.files[0].name : false;
          if (fileName) {
            const fileNameTruncated = fileName.slice(0, 14) + "...";
            fileNameDisplay.textContent = fileNameTruncated;
            fileContainer.classList.add("has-content");
          } else {
            fileContainer.classList.remove("has-content");
          }
        });

        fileContainer.addEventListener("click", function () {
          input.click();
        });
      }

      if (input.type == "select-one") {
        input.addEventListener("focus", function () {
          this.closest(".group").classList.remove("empty");
        });
      }

      input.addEventListener("focus", () => {
        const group = input.closest(".group");
        group.classList.add("has-content");
      });

      input.addEventListener("blur", () => {
        const group = input.closest(".group");
        if (input.value.trim() === "") {
          group.classList.remove("has-content");
        }
      });
    }
  });
});
